<template functional>
  <button
    :class="['blue-btn', props.extraClass]"
    :disabled="props.disabled"
    @click="listeners.click"
  >
    <slot></slot>
  </button>
</template>

<script>
export default {
  props: {
    disabled: Boolean,
    extraClass: String,
  },
};
</script>
